import React from 'react';

export const CheckMarkIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="6"
    viewBox="0 0 8 6"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M168.152,92.718a0.836,0.836,0,0,0,.335.555l2.8,2.038a0.871,0.871,0,0,0,1.2-.165l3.533-4.556a0.827,0.827,0,0,0-.166-1.176,0.87,0.87,0,0,0-1.2.161l-3.017,3.892-2.115-1.539a0.869,0.869,0,0,0-1.2.17A0.818,0.818,0,0,0,168.152,92.718Z"
      transform="translate(-168.156 -89.219)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/check-mark-icon.js